import { MS_IN_HOUR } from '~/src/common/time-constants';

export const LAST_CLOSED_DEFAULT_BANNER_STORAGE_KEY = 'default_last_closed_banner';

export const showInAWhileIntervalInMs = MS_IN_HOUR * 4;
